<template>
  <div class="chart-box" v-loading="loading">
    <el-row>
      <el-col :span="14">
        <div class="checkbox">
          <div
            v-for="[id, name] in chartPlatFormMap"
            :key="id"
            :class="{active: id === active}"
            @click="handleClickPlatForm(id)"
          >
            {{ name }}
          </div>
        </div>
      </el-col>
    </el-row>
    <div ref="chart-el" class="chart" />
  </div>
</template>

<script>
import { Chart, DataView } from '@/utils/g2'
import { chartPlatFormMap } from '../../mixin'
import dataService from '@/api/data'
import dayjs from 'dayjs'

export default {
  name: 'TrendChart',

  props: {
    trackId: {
      type: Number,
      required: true
    },
    isIndex: {
      type: Boolean,
      default: false
    },
    cycle: {
      type: Number,
      required: true
    },
    platform: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      active: 'tme',
      loading: true,
      chart: null,
      data: [],
      chartPlatFormMap,
      labels: {
        0: [this.$t('data.apply.streams'), this.$t('data.apply.downloads'), this.$t('data.apply.favorites'), this.$t('data.apply.remarks')],
        1: [this.$t('data.apply.streamsIndex'), this.$t('data.apply.downloadsIndex'), this.$t('data.apply.favoritesIndex'), this.$t('data.apply.remarksIncrease')]
      },
    }
  },

  watch: {
    platform(newVal) {
      this.active = newVal
    },
  },

  beforeDestroy() {
    this.destroyChart()
  },

  async mounted() {
    await this.fetchAll()
    // 可能组件已经销毁，此时无法render报错
    try {
      this.renderChart()
    } catch (e) {
      //
    }
  },

  methods: {
    destroyChart() {
      this.chart && this.chart.destroy()
    },
    handleClickPlatForm(id) {
      this.active = id
      this.resouceData()
    },

    async resouceData() {
      await this.fetchAll()
      const dv = this.dataInit()
      this.chart.changeData(dv)
    },

    dataInit() {
      const dv = new DataView().source(this.data)
      const label = this.labels[+this.isIndex]

      dv.transform({
        type: 'rename',
        map: {
          playCnt: label[0],
          downloadCnt: label[1],
          favCnt: label[2],
          [this.isIndex ? 'commentCntRate' : 'commentCnt']: label[3]
        }
      })

      dv.transform({
        type: 'map',
        callback: (row) => {
          row.impDate = dayjs(row.impDate).format('YYYY-MM-DD')
          return row
        },
      })

      dv.transform({
        type: 'fold',
        fields: label,
        key: 'type',
        value: 'count'
      })

      return dv.rows
    },

    async fetchAll() {
      try {
        this.loading = true
        const { list } = await dataService.queryWordDataTrends({
          track_id: this.trackId,
          platform: this.active,
          cycle: this.cycle
        })
        this.data = list
      } catch (error) {
        this.$message.error(error.message)
      } finally {
        this.loading = false
      }
    },

    renderChart() {
      this.chart = new Chart({
        container: this.$refs['chart-el'],
        autoFit: true,
        width: 700,
        height: 400,
        padding: [20, 50, 120, 80]
      })

      const dv = this.dataInit()

      this.chart.data(dv)

      this.chart.axis('impDate', {
        grid: {
          type: 'line',
          lineStyle: {
            stroke: '#d9d9d9',
            lineWidth: 1,
            lineDash: [4, 4]
          }
        },
      })

      this.chart.axis('count', {
        grid: {
          type: 'line',
          lineStyle: {
            stroke: '#d9d9d9',
            lineWidth: 1,
            lineDash: [4, 4]
          }
        },
      })

      this.chart.scale('impDate', {
        type: 'time',
        tickCount: 7,
      })

      this.chart
        .line()
        .position('impDate*count')
        .color('type', ['#1672FA', '#32DDE9', '#F34686', '#00000'])

      this.chart.render()

      this.chart.legend('type', {
        position: 'bottom-center'
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.chart-box {
  padding: 18px;
  height: 440px;
  overflow: hidden;
}

.chart {
  margin-top: 20px;
}

.checkbox {
  div {
    cursor: pointer;
    margin-right: 10px;
    display: inline-block;
    padding: 0 20px;
    height: 30px;
    line-height: 30px;
    background-color: #8D99AD;
    color: #fff;
    border-radius: 15px;
    transition: background-color 0.3s ease-in-out;
    &.active {
      background-color: #1572FB;
    }
  }
}

.date-picker {
  width: 100%;
  &::v-deep {
    .el-range-input{
      width: 100px;
    }
    .el-range-separator {
      width: 20px;
    }
  }
}
</style>
